import React, { useContext, useEffect, useState } from "react";
import { useNavigationBar } from "../../../context/NavigationContext";
import { useLocation, useNavigate } from "react-router-dom";
import { updateChannel } from "../../../api/channels/channelServices";
import { CreateChannelContext } from "../../../context/CreateChannelContext";
import LoadingPopup from "./LoadingPopup";
import { Timestamp } from "firebase/firestore";
import { ContentAgeRestriction } from "../../../api/enums";
import { EditChannelContext } from "../../../context/EditChannelContext";

interface ChannelAgeProps {
  isEdit?: boolean;
}
export default function ChannelAge({ isEdit = false }: ChannelAgeProps) {
  const ageData = [
    {
      id: 1,
      title: "Age 4+",
      age: ContentAgeRestriction.fourPlus,
      description:
        "*Content suitable for children aged 4 and older.* Contains minimal or no violence, mild language, and positive themes. Appropriate for young audiences.",
    },
    {
      id: 2,
      title: "Age 9+",
      age: ContentAgeRestriction.ninePlus,
      description:
        "*Not suitable for children under the age of 9.* Contains mild or infrequent occurrences of mature or suggestive content, moderate language and themes.",
    },
    {
      id: 3,
      title: "Age 12+",
      age: ContentAgeRestriction.twelvePlus,
      description:
        "*Not suitable for children under the age of 12.* Contains stronger or more frequent occurrences of mature or suggestive content, stronger language and complex themes.",
    },
    {
      id: 4,
      title: "Age 17+",
      age: ContentAgeRestriction.seventeenPlus,
      description:
        "*Not suitable for children under the age of 17.* Contains frequent or intense occurrences of mature or suggestive content, strong language and mature themes.",
    },
  ];

  const editChannelContext = useContext(EditChannelContext);
  const createChannelContext = useContext(CreateChannelContext);
  const channelData = isEdit ? editChannelContext?.channelEditData : createChannelContext?.channelData;
  const loading = isEdit ? editChannelContext?.loading : createChannelContext?.loading;
  const updateChannelData = isEdit ? editChannelContext?.updateChannelEditData : createChannelContext?.updateChannelData;
  const updateDataOnServer = isEdit ? editChannelContext?.updateEditDataOnServer : createChannelContext?.updateDataOnServer;

  const navigate = useNavigate();
  const { setNavProps } = useNavigationBar();
  // const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [channelState, setChannelState] = useState({ key: "", value: "" });

  // useEffect(() => {
  //   return () => {
  //     updateChannelData(prev => ({ ...prev, editUpdateDate: Timestamp.now() }));
  //   };
  // }, []);

  useEffect(() => {
    setNavProps({
      backArrow: false,
      subtitle: "Channel",
      title: "Age Rating",
      buttonTitle: "Done",
      filterOption: true,
      enableLink: channelData.age ? true : false,
      //onBack: () => alert("Back Clicked"),
      //onFilter: () => {},
      onNext: () => {
        updateDataOnServer && updateDataOnServer();
        navigate(-1);
      },
      onClose: () => {
        navigate(-1);
      },
    });
  }, [setNavProps, navigate, channelData]);

  const handleClick = (title: string, age: number) => (event: React.MouseEvent<HTMLElement>) => {
    updateChannelData({ ...channelData, age });
  };

  const renderDescription = (description: string) => {
    return description.split(/(\*.*?\*)/g).map((part, index) => {
      if (part.startsWith("*") && part.endsWith("*")) {
        return (
          <span key={index} className="font-bold">
            {part.slice(1, -1)}
          </span>
        );
      }
      return part;
    });
  };

  return (
    <div className="channel-page-context">
      <LoadingPopup isLoading={loading} />
      <div className="flex flex-col">
        <div className="flex flex-col w-full mb-5">
          <div className="flex flex-col w-full mb-5">
            <label className="title_inner_page">Choose the Age Rating of your Channel</label>
            <label className="notes_inner_page">Choose the age rating based on the appropriateness of your content for children.</label>
            <div className="px-[1px] flex flex-col w-full pt-[15px]">
              <ul className="space-y-4">
                {ageData.map(item => (
                  //{items.map((item, index) => (
                  <li onClick={handleClick(item.title, item.age)} key={item.id} className="flex bg-white age-certificate-divider-item">
                    <img
                      src={channelData.age === item.age ? "/svg/circlechecked.svg" : "/svg/circle.svg"}
                      alt={item.title}
                      className="object-cover w-5 h-5"
                    />
                    <div className="flex-1 ml-5 space-4">
                      <p className="content-subtitle-text">{item.title}</p>
                      <p className="notes-class-light mb-[15px]">{renderDescription(item.description)}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
